import Component from './Component';
import React from 'react';

export default class AbcdInput extends Component {

	handleClick(char) {
		if (char == this.props.value) {
			this.props.onChange(null);
		}
		else {
			this.props.onChange(char);
		}
	}

	render() {
		const arr = [];
		for (let i = 65; i <= 90; i++) {
			arr.push(String.fromCharCode(i));
		}
		const buttons = arr.map((item) => {
			const active = item == this.props.value;
			return <span className={'letter' + (active ? ' active' : '')} onClick={() => this.handleClick(item)} key={item}>{item}</span>;
		});
		return <div className="abcdinput">{buttons}</div>;
	}
}


// WEBPACK FOOTER //
// ./src/reactis/reactis-inputs/AbcdInput.js